var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55843 6.85057C6.25179 7.17102 5.75595 7.17102 5.45258 6.85057L0.229977 1.39602C-0.0766591 1.07557 -0.0766591 0.557386 0.229977 0.240341C0.536613 -0.0767046 1.03245 -0.0801136 1.33583 0.240341L6.00061 5.11534L10.6654 0.240341C10.972 -0.0801136 11.4679 -0.0801136 11.7712 0.240341C12.0746 0.560795 12.0779 1.07898 11.7712 1.39602L6.5519 6.85057H6.55843Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.e3c27cbc85da380f68c8ff36365f1d6c.svg";
export { ForwardRef as ReactComponent };